<button
  class="cart-list-item-mobile-delete text-b4-m-500 color-white"
  (click)="removeItem.emit()"
  [style.transform]="'translateX(' + (swipeOffset() + 90) + 'px)'"
>
  <sd-icon [type]="iconTypes.DELETE"></sd-icon>
  удалить
</button>
